import { useEffect } from 'react';

import { AccountColumns } from '@/views/containers/planning/data-tables/plan-accounts-table/useAccountColumnsDefinition';

import { CurrentContact } from '@/redux/modules/types/contacts';

import { formatMessage } from '@/utils/i18n';
import notification from '@/utils/notification';
import { useContactPlanAccounts } from '@/hooks/planning/useContactPlanAccounts';
import { filterImportedAccounts } from '@/utils/planning';

type UseDataProps = {
  currentContact: CurrentContact;
};

export const useData = ({ currentContact }: UseDataProps) => {
  const i18nBasePath = 'Contacts.ContactTabs.PlanAccounts';
  const tableColumns = [
    AccountColumns.NAME,
    AccountColumns.LINKED_PORTFOLIO,
    AccountColumns.TOTAL_VALUE,
    AccountColumns.RISK_PROFILE,
    AccountColumns.TARGET_RATE_OF_RETURN,
    AccountColumns.ACTION_CREATE_PORTFOLIO,
  ];
  const { isLoading, error, plan } = useContactPlanAccounts({ contact: currentContact.contact });
  const importedAccounts = filterImportedAccounts(plan?.accounts ?? []);
  const displayContent = plan && importedAccounts.length > 0 && plan.contactId;

  // Handle error notification when there's an actual error (not 404)
  useEffect(() => {
    const hasError = error && 'status' in error;
    const isNot404Error = hasError && error.status !== 404;

    if (isNot404Error) {
      notification.error(formatMessage(`${i18nBasePath}.Notifications.Get.Failed`));
    }
  }, [error, i18nBasePath]);

  return {
    i18nBasePath,
    tableColumns,
    displayContent,
    importedAccounts,
    plan,
    isLoading,
    error,
  };
};
